import { Button } from "@workspace/web-ui/components/button";
import { Image } from "@workspace/web-ui/components/image";

type EmptyStateCardProps = {
  title: string;
  description?:string;
  message: string;
  image: string;
  altImg: string;
  buttonText?: string;
  onButtonClick?: () => void;
  showButton?: boolean;
};

const EmptyMedicalCard: React.FC<EmptyStateCardProps> = ({
  message,
  image,
  altImg,
  description,
  buttonText,
  onButtonClick,
  showButton
}) => {
  return (
    <div className="rounded-xl bg-white w-full text-center mb-4">
      <div className="flex flex-col items-center justify-center py-10">
        <Image src={image} alt={altImg} className="size-14 mb-1" layout="constrained" width={96} height={96} />
        <h4 className="text-lg py-2 font-medium">{description}</h4>
        <p className="text-base text-gray-500 max-w-md">{message}</p>
        {showButton && buttonText && onButtonClick && (
          <Button className="mt-5 bg-[#4272DD] px-4 py-1 rounded-lg" onClick={onButtonClick}>
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default EmptyMedicalCard;